



























import { SfImage } from "@storefront-ui/vue";
import { computed, defineComponent, ref } from "@nuxtjs/composition-api";
import { useConfig, useGtm } from "~/composables";

export default defineComponent({
  name: "HeaderLogo",
  components: { SfImage },
  props: {
    isShowNav: {
      type: Boolean,
    },
    toHideNav: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const { eventCustomlinksInteracted } = useGtm();
    const isShowNav = ref(props.isShowNav);
    const { config } = useConfig();

    const logoSrc = computed(() => {
      const baseMediaUrl = config.value.base_media_url;
      const logo = config.value.header_logo_src;

      return baseMediaUrl && logo ? `${baseMediaUrl}logo/${logo}` : "";
    });

    const logoWidth = computed(() => config.value.logo_width || "35");

    const logoHeight = computed(() => config.value.logo_height || "34");

    const logoAlt = computed(() => config.value.logo_alt || "");
    const closeNav = () => {
      if (!isShowNav.value) {
        emit("toHideNav", isShowNav.value);
      }
    };
    const logoTracking = () => {
      eventCustomlinksInteracted({
        "eventlabel": 'Logo',
        "eventCategory": "Top Header",
      });
    };

    return {
      logoTracking,
      logoAlt,
      logoHeight,
      logoSrc,
      logoWidth,
      closeNav,
    };
  },
});
